import type { AuthTokens, User } from 'modules/auth/types';

export default function getAuthUser({ accessToken }: AuthTokens): User {
    return accessToken?.user ?? ({} as User);
}
